import React from 'react'
import  "../../CSS/Blog/titulo.css"

const Titulo = () => {
  return (
    <div>
      <h3 className='tituloBlog'>January 5, 2023 <br/> Perfume Collections</h3>
    </div>
  )
}

export default Titulo